module.exports = __webpack_public_path__ + "static/media/RP-A_S_Timeless_Sforza_Sand.033d230b.png";